import type { SendEventParams } from '~/shared/analytix'

import { SnapshotMap } from '../../general/snapshot-map'

const SNAPSHOTS_TO_KEEP = 0

export type SessionStartParameters = SendEventParams.SessionStart

/**
 * SnapshotMap to store `session_start` event parameters with their history
 */
export const parameters = new SnapshotMap<SessionStartParameters>(
  SNAPSHOTS_TO_KEEP,
  [['userAgent', navigator.userAgent]]
)
